export default {
  ariaLabels: {
    street: {
      en: 'Recommended street address',
    },
    city: {
      en: 'Recommended city',
    },
    state: {
      en: 'Recommended state',
    },
    zipCode: {
      en: 'Recommended zip code',
    },
    apt: {
      en: 'Recommended apt',
    },
  },
}
